import HeroV2Widget from './HeroV2Widget';

export default HeroV2Widget;
